import { Disclaimer, Div, P, lightTheme } from '@vgrubs/components';
import { PlaybookTiming } from '../playbookContent';
import { TimingRow, TimingValue } from './TimingTable.styled';

type Props = {
  rows: PlaybookTiming[];
};

/** How long each marketplace takes to go live, one line per marketplace. */
export const TimingTable = ({ rows }: Props) => (
  <Div>
    {rows.map((row) => (
      <TimingRow key={row.provider}>
        <P $m="0" $bold>
          {row.provider}
        </P>
        <TimingValue>
          <P $m="0">{row.timing}</P>
          {row.note && (
            <Disclaimer $m="0" $color={lightTheme.lightGray}>
              {row.note}
            </Disclaimer>
          )}
        </TimingValue>
      </TimingRow>
    ))}
  </Div>
);
